import Cookies from 'universal-cookie';
import { SAAS_COOKIE_NAME } from '@utils/constants';
import { SAAS_TOKEN_KEY, MKP_TOKEN_KEY } from '@kiute-tech/network-kiute-pro';

type cookieType = {
    token?: string;
    marketplaceToken?: string;
};

const saasCookieManager = (): void => {
    try {
        const cookies = new Cookies();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const cookieKiutePro: cookieType = cookies.get(SAAS_COOKIE_NAME);

        if (cookieKiutePro?.token) {
            localStorage.setItem(SAAS_TOKEN_KEY, cookieKiutePro.token);
        }

        if (cookieKiutePro?.marketplaceToken) {
            localStorage.setItem(
                MKP_TOKEN_KEY,
                cookieKiutePro.marketplaceToken,
            );
        }
    } catch (error) {
        console.warn('=== saasCookieManagerersror ===', error);
    }
};

export const cleanSaasCookie = (): void => {
    const cookies = new Cookies();
    cookies.remove(SAAS_COOKIE_NAME);
};

saasCookieManager();
